export default {_name:'Text.Chip',module:'Field',view:'Element/Text/Chip',options:{xs:'auto'},mobileOptions:{ms:'auto'}}